<template>
    <div class="SubstationManagement subpostation" >
        <div id="left">
            <div class="Placeholder"></div>
            <div id="areachart"  class="row-center" style=" justify-content: space-between;">
                <div class="EchartsLeft" >
                   <div class="title">发电功率</div>
                    <!-- <div class="capacity">容量：120kWp</div> -->
                    <div class="tabCharts">
                        <div id="my_echarts" style="height:100%;width:100%"></div>
                    </div>
                </div>
                <div class="EchartsRight statistics">
                    <div class="title">发电统计</div>
                    <div class="name">近7日发电量</div>
                    <div class="tabCharts" style="height:22vh">
                        <div id="my_echarts3" style="height:100%;width:100%"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="rightYuanqu">
            <div class="top">
                <div>
                    <div class="title">
                        <img :src="AreaInfo.areaImg" alt="">
                        <div class="titler">
                            <div class="titleName">{{AreaInfo.areaName}}</div>
                            <span @click.prevent.stop="isShowArea = !isShowArea" >切换<img src="../../assets/img/change0.png" alt=""></span>
                            <div v-if="isShowArea" ref="area">
                                <Href @closedArea='closedArea'></Href>
                            </div>
                        </div>
                        <button @click="backYuanqu">返回园区</button>
                    </div>
                </div>
                <div class="motion">自{{startTime}}起，已安全运行 <span>{{projectTime}}</span> 天</div>
                <div class="area row-center">
                    <div class="item">
                        <div class="name">今日发电</div>
                        <div class="num" >{{Number(carbon/0.7244).toFixed(2)}}kWh</div>
                    </div>
                    <div class="item">
                        <div class="name">等效小时</div>
                        <div class="num" >{{equivalent.equivalent}}h</div>

                    </div>
                    <div class="item">
                        <div class="name">装机总容量</div>
                        <div class="num" >120kWp</div>
                    </div>
                    <div class="item"> 
                        <div class="name">网关在线</div>
                        <div class="num online"><span>2</span>/2</div>
                    </div>
                </div>
            </div>
            <div class="overviewInverter">
                <div class="title">逆变器概况</div>
                <div class="looptable">
                    <el-table
                        row-class-name="rowName"
                        header-row-class-name="headerName"
                        height="25vh"
                        width="100%"
                        border
                        :data="InverterList"
                        stripe
                        >
                        <el-table-column
                        class-name="name"
                        prop="loopName"
                        label=""
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="val1"
                        align="center"
                        label="日发电量"
                        >
                            <template slot-scope="scope">
                                {{mqttval(scope.row.subLoopUrl+"/"+'Daily_Power_Generation')}}kWh
                            </template>
                        </el-table-column>
                        <el-table-column
                        prop="val2"
                        align="center"
                        label="总有功功率">
                            <template slot-scope="scope">
                                {{mqttval(scope.row.subLoopUrl+"/"+'P')}}W
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
               
            </div>
            <!-- <TodayEvent/> -->
            <div class="EchartsRight statistics">
                <div class="title">环保效益</div>
                <div class="cont row-center">
                    <div class="item">
                        <div class="name">今日碳减排</div>
                        <div class="num">{{carbon}}<span>kg</span></div>
                    </div>
                    <div class="item">
                        <div class="name">今日节约标准煤</div>
                        <div class="num">{{saveCoal}}<span>kg</span></div>
                    </div>
                    <div class="item">
                        <div class="name">累计碳减排</div>
                        <div class="num">{{reduction}}<span>kg</span></div>
                    </div>
                    <div class="item">
                        <div class="name">累计节约标准煤</div>
                        <div class="num">{{emission}}<span>kg</span></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {projectTime } from '../../api/common'
    import Videoone from "./components/videoone";
    const Href = ()=>import('./components/href.vue')
    const TodayEvent = ()=>import('./components/newComponts/todayEvent.vue')
    import {
        GET_AREAS,InverterArea,dailyPower,DailyHistorycurve
    } from "../../api/power";
    import {
        getSevenDays,getLastOrNextFewDateBy
    } from "../../util/date";
    import {
		dateFormat,
		dayEnd,
		dayStart,
		nextDay,
		nextMonth,
		nextYear,
		perDay,
		perMonth,
		perYear,
	} from "../../util/DateUtil";
	import { floatFormat } from "../../util/MathUtil";
    import * as echarts from 'echarts';
    export default { 
        name: "SubstationManagement",
        data() {
            return {
                tabSdx:0,
                isShowArea:false,
                allArea:[],
                AreaInfo:{},
                projectTime:'',
                startTime:"",
                InverterList:[]
            };
        },
        watch: {
            '$route.query.id'(n,o){
                this.AreaInfo = this.allArea.filter((e) => e.areaId == n)[0];
            }
        },
        mounted() {
            this.$store.commit("Dthere", 3);

            let d = new Date(this.$store.state.project.projectInfo.deploymentTime)
            this.startTime = d.getFullYear() + "年"+ (d.getMonth() + 1) +"月"+ d.getDate() +"日";

            this.getProjectTime()
            this.echartsInit()
            document.addEventListener('click', this.closePopover);
            this.energyCharts("my_echarts3");

            GET_AREAS().then(res => {
                this.allArea = res.data.data.areas;
                this.AreaInfo = this.allArea.filter((e) => e.areaId == this.$route.query.id)[0];
            })

            this.getInverterArea()
        },
        beforeDestroy() {
             document.removeEventListener("click", this.closePopover);
        },
        components: {
            Videoone,Href,TodayEvent
        },
        computed:{
			mqttval() {
				return this.getMqttVal(this.$store.getters.mqttVal);
			},//今日碳减排
            carbon(){
                let sum = 0
                this.InverterList.forEach((item,index) =>{
                    if(this.mqttval(item.subLoopUrl+"/"+'Daily_Power_Generation')=='--'){
                        return '--'
                    }else{
                        item = (this.mqttval(item.subLoopUrl+"/"+'Daily_Power_Generation') * 0.7244)
                        sum += Number(item)
                    }
                    
                })
                return sum.toFixed(2)
            },//今日节约标准煤
            saveCoal(){
                let sum = 0
                this.InverterList.forEach((item,index) =>{
                    if(this.mqttval(item.subLoopUrl+"/"+'Daily_Power_Generation')=='--'){
                        return '--'
                    }else{
                        item = (this.mqttval(item.subLoopUrl+"/"+'Daily_Power_Generation') * 0.12303)
                        sum += Number(item)
                    }
                })
                return sum.toFixed(2)
            },//累计
            reduction(){
                let sum = 0
                this.InverterList.forEach((item,index) =>{
                    if(this.mqttval(item.subLoopUrl+"/"+'Total_Power_Generation')=='--'){
                        return '--'
                    }else{
                    item = (this.mqttval(item.subLoopUrl+"/"+'Total_Power_Generation') * 0.7244)
                    sum += Number(item)
                    }
                })
                return sum.toFixed(2)
            },//累计节约
            emission(){
                let sum = 0
                this.InverterList.forEach((item,index) =>{
                    if(this.mqttval(item.subLoopUrl+"/"+'Total_Power_Generation')=='--'){
                        return '--'
                    }else{
                        item = (this.mqttval(item.subLoopUrl+"/"+'Total_Power_Generation') * 0.12303)
                        sum += Number(item)
                    }
                })
                return sum.toFixed(2)
            },
            equivalent(){
                let hour = new Date().getHours()
                let month = new Date().getMonth() + 1
                let year = new Date().getFullYear()
                let day = new Date().getDate()

                let obj = {
                        equivalent:0 ,        // 等效
                        todayPowerOut:0,      // 放电量
                        todayPowerIn:160,     // 充电量
                        todayPowerSend:160,     // 放电量
                    }
                
                
                if(this.$store.state.project.weather==1||this.$store.state.project.weather==2){
                    // 等效小时
                    obj.equivalent = (4.5  * ((hour - 6) / 12 ))>4.5?4.5:(4.5  * ((hour - 6) / 12 )).toFixed(2)

                    // 计算发电量
                    let seriesData = [0, 0, 0, 0, 0, 0, 3, 8, 17, 29, 47, 55, 57, 57, 54, 46, 38, 15, 7, 3, 0, 0, 0, 0, 0 ]
                    obj.todayPowerSend = eval(seriesData.splice(0,hour + 1).join("+"))

                }else{
                    obj.equivalent = (8 * ((hour - 6) / 12 )) > 8 ? 8 : (8 * ((hour - 6) / 12 )).toFixed(2)
                    
                    // 计算发电量
                    let seriesData = [0, 0, 0, 0, 0, 0, 7, 10, 31, 60, 90, 110,  117, 114,  109, 91, 61, 31, 11, 9, 0, 0, 0, 0, 0 ]
                    obj.todayPowerSend = eval(seriesData.splice(0,hour + 1).join("+"))
                }

                let timeC = new Date().getTime()
                let timeA = new Date(`${year}-${month}-${day} 20:00:00`).getTime()
                let timeB = new Date(`${year}-${month}-${day} 17:00:00`).getTime()

                // 8点到10点放电电量 
                if(hour >= 20 && hour<= 22){
                    let timeP = (timeC - timeA) / 1000 / 7200 * 160
                    obj.todayPowerOut = timeP.toFixed(2)
                }else{
                    obj.todayPowerOut = 0
                }

                // 0点到4点充电电量
                if(hour >= 0 && hour<= 4){
                    let timeP = (timeC - timeB) / 1000 / 3600 * 400 * 160
                    obj.todayPowerIn = timeP.toFixed(2)
                }else{
                    obj.todayPowerIn = 160
                }

                return obj
            },
        },
        methods: {
			getMqttVal(f) {
				return (k, m) => {
					if (k) {
						// k = currentLoop.subLoopUrl + "/" + k;
						let mqttVal = f(k);
						mqttVal = floatFormat(mqttVal, 2);
						if (typeof mqttVal === "object") {
							return mqttVal;
						}
						return mqttVal !== undefined && !isNaN(mqttVal) ? mqttVal : "--";
					} else {
						return "--";
					}
				};
			},
            //逆变器
            async getInverterArea(){
                let areaId = this.$route.query.id
                let response = await InverterArea(areaId);
                this.InverterList = response.data.data.loops || [];
            },
            async getProjectTime(){
                let res = await projectTime()
                this.projectTime = res.data.data.day
            },
            closePopover(e){
                let self = this;
                if (self.$refs.area && !self.$refs.area.contains(e.target)) {
                    if (self.isShowArea == true){
                        self.isShowArea = false
                    }
                }
            },
            async energyCharts(val){
                let xData = getLastOrNextFewDateBy(new Date())
                let year = new Date().getFullYear()
                let result = await dailyPower({
                    start:`${year+'-'+xData[0].replace("/","-")}T00:00:00Z`,
                    end:`${year+'-'+xData[6].replace("/","-")}T24:00:00Z`,
                    projectId: this.$store.state.project.projectInfo.projectId,
                });
                let data = result.data.data.points.map(e=>Number(e).toFixed(2))
                var chartDom = document.getElementById(val);
                var myChart = echarts.init(chartDom);
                myChart.setOption({
                    xAxis: {
                        type: 'category',
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        name:'kWh'
                    },
                    series: [{
                        data:data,
                        type: 'bar',
                        barWidth:15,
                        itemStyle:{
                            color:'#5B8FF9',
                            barBorderRadius:[7,7,0,0]
                        }
                    }],
                    grid: {
                        left: "0%",
                        right: "0%",
                        bottom: "4%",
                        top: "15%",
                        containLabel: true,
                    },
                    
                    tooltip: {
                        trigger: 'axis'
                    },
                })
            },
            closedArea(){
                this.isShowArea = false
            },
            async echartsInit(){
                var chartDom = document.getElementById('my_echarts');
                var myChart = echarts.init(chartDom);
                let result = await DailyHistorycurve({
                    start: dayStart(new Date()),
					end: dayEnd(new Date()),
                    projectId: this.$store.state.project.projectInfo.projectId,
                    node:"P"
                });
                let data = result.data.data.points.map(e=>Number(e/1000).toFixed(2))
                let day1 = new Date();
                day1.setDate(day1.getDate() - 1);
                let result1 = await DailyHistorycurve({
                    start: dayStart(day1),
					end: dayEnd(day1),
                    projectId: this.$store.state.project.projectInfo.projectId,
                    node:"P"
                });
                let data1 = result1.data.data.points.map(e=>Number(e/1000).toFixed(2))

                let temp = []
                for (let i = 0; i <= 24; i++) {
                    temp.push(i + "点")
                }
                myChart.setOption({
                    
                    grid: {
                        left: "0%",
                        right: "3%",
                        bottom: "4%",
                        top: "15%",
                        containLabel: true,
                    },
                    legend: {
                        x:'right',      //可设定图例在左、右、居中
                        itemHeight: 14,
                        itemWidth: 14,
                        itemGap: 10,
                        icon: 'rect',
                        textStyle:{
                            fontSize: "16rem",//字体大小
                        },
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data:temp
                    },
                    yAxis: {
                        type: 'value',
                        name:"容量：120kWp",
                        nameTextStyle:{
                            padding: [0,0 ,0,54],
                            fontSize:"16rem",  
                            color:"#333"
                        }
                    },
                    series: [
                        {
                            name: '今日',
                            data: data,
                            type: 'line',
                            smooth: true,
                            itemStyle: {
                                color: '#0D94FF'
                            },
                            areaStyle: {
                                color:{
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [{
                                        offset: 0, color: 'rgba(58,132,255, 0.4)' // 0% 处的颜色
                                    }, {
                                        offset: 1, color: 'rgba(58,132,255, 0)' // 100% 处的颜色
                                    }],
                                    global: false // 缺省为 false
                                }
                            }
                        },
                        {
                            name: '昨日',
                            data: data1,
                            type: 'line',
                            smooth: true,
                            itemStyle: {
                                color: '#5AD8A6'
                            },
                            areaStyle: {
                                color:{
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [{
                                        offset: 0, color: 'rgba(90,216,166, 0.4)' // 0% 处的颜色
                                    }, {
                                        offset: 1, color: 'rgba(90,216,166, 0)' // 100% 处的颜色
                                    }],
                                    global: false // 缺省为 false
                                }
                            }
                        },
                    ]
                })
            },
            backYuanqu(){
                this.$router.push('SubstationManagement')
                this.$store.commit("Dthere", 1);
                this.$store.commit("webId", null);

            }
        },
    };
</script>
<style scoped lang="less">
.subpostation{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
/deep/.headerName{
    th{
        background: rgba(0, 43, 102, 0.03);
        border-bottom: 0;
        font-size: 16rem;
        color: #333;
        font-weight: 400;
        height: 6vh;
        padding: 0;
    }
    
}
/deep/.rowName{
    td{
        border-bottom: 0;
        font-size: 16rem;
        color: #0D94FF;
        font-weight: 400;
        height: 6vh;
        padding: 0;
    }
    .name{
        color: #333;

    }
}
/deep/.el-table--border::after, /deep/.el-table--group::after, /deep/.el-table::before{
    content: none;
}
/deep/.el-table--border,/deep/ .el-table--group{
    border: 0;
}
.looptable{
    overflow: hidden;
    table{
        width: 100%;
        td{
            height: 60rem;
            text-align: center;
            font-size: 16rem;
            // width: 20%;
        }
        tr:nth-child(odd){
            background: rgba(0, 43, 102, 0.03);
        }
        tr td:nth-child(even){

            background: rgba(0, 43, 102, 0.03);
        }
        .name{
            color: #0D94FF;
        }
    }
}
.statistics{
    height: 29.62962963vh !important;
    .name{
        text-align: center;
        font-size: 18rem;
    }
    .cont{
        justify-content: space-between;
        .item{
            background: rgba(0, 43, 102, 0.03);
            width: 49.2%;
            height: 11vh;
            text-align: center;
            margin-bottom: 8rem;
            .name{
                font-size: 18rem;
                margin-top: 2.5vh;
            }
            .num{
                font-size: 30rem;
                font-weight: bold;
                color: #0D94FF;
            }
            span{
                font-size: 20rem;
                margin-left: 3rem
            }
        }
    }
}
.EchartsLeft,.EchartsRight{
    .w(528);
    background: #ffffff;
    height: 100%;
    padding:20rem 23rem;
    position: relative;
    .capacity{
        color: #999999;
        font-size: 18rem;
        overflow: hidden;
        clear: both;
        position: absolute;
        top: 56rem;
        right: 20px;
    }
    .title{
        font-size: 18rem;
        font-weight: bold;
        margin-bottom: 10rem;
    }
}
    .motion{
        font-size: 18rem;
        text-align: center;
        height: 6vh;
        line-height: 6vh;
        background: rgba(0, 43, 102, 0.04);
        border-radius: 8rem;
        margin-bottom: 33rem;
        span{
            color: #0D94FF;
            font-size: 30rem;
            font-weight: bold;
            vertical-align: -4px;
        }
    }
    .area{
        justify-content: space-between;
        .item{
            // width: 25%;
            text-align: center;
            .name{
                font-size: 18rem;
                height: 30px;
            }
            .num{
                color: #0D94FF;
                font-size: 20rem;
                font-weight: bold;
            }
            
            .online{
                color: #333;
                span{
                    color: #68D86A;
                }
            }
        }
    }
    
</style>